
const prefix = 'STATISTICS_';

export const statisticsConstants = {
    UPDATE_PLAYER_COUNTS: prefix + 'UPDATE_PLAYER_COUNTS',
    UPDATE_PLAYER_COUNTS_RESPONSE: prefix + 'UPDATE_PLAYER_COUNTS_RESPONSE',
    UPDATE_CHARTS_RESPONSE: prefix + 'UPDATE_CHARTS_RESPONSE',
    UPDATE_STATS_RESPONSE: prefix + 'UPDATE_STATS_RESPONSE'
};
